import React from 'react';
import { View, TextInput, Pressable, StyleSheet, Platform } from 'react-native';
import { FontAwesome6 } from '@expo/vector-icons';
import colors from '../../lib/colors';
import { useFontLoading } from '../../lib/FontContext';
import { interRegular } from '../../lib/fonts';

interface SearchInputProps {
    value: string;
    onChangeText: (text: string) => void;
    placeholder?: string;
}

export default function SearchInput({ value, onChangeText, placeholder = 'Search...' }: SearchInputProps) {
    const { fontsLoaded } = useFontLoading();

    return (
        <View style={styles.container}>
            <View style={styles.wrapper}>
                <FontAwesome6 name="magnifying-glass" size={16} color={colors.text500} style={styles.icon} />
                <TextInput
                    style={[styles.input, fontsLoaded && interRegular]}
                    placeholder={placeholder}
                    placeholderTextColor={colors.text500}
                    value={value}
                    onChangeText={onChangeText}
                />
                {value.length > 0 && (
                    <Pressable onPress={() => onChangeText('')} style={styles.clearButton}>
                        <FontAwesome6 name="xmark" size={18} color={colors.text500} />
                    </Pressable>
                )}
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        marginBottom: 32,
    },
    wrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#ffffff',
        borderWidth: 1,
        borderColor: colors.border,
        borderRadius: 12,
        paddingHorizontal: 16,
        paddingVertical: 12,
    },
    icon: {
        marginRight: 12,
    },
    input: {
        flex: 1,
        fontSize: 16,
        color: colors.text900,
        ...(Platform.OS === 'web' && {
            outlineStyle: 'none',
        } as any),
    },
    clearButton: {
        marginLeft: 8,
        padding: 4,
    },
});
